<div *ngIf="cs.isBrowser" class="unlock-with-points-modal">
  <div *ngIf="balanceLoading" class="unlock-with-points-modal__loading">
    <button type="button" class="unlock-with-points-modal__icon-btn" (click)="close()" [attr.aria-label]="TEXT.DEFAULT_HEADER">
      <em class="icon-arrow-back"></em>
    </button>
    <div class="unlock-with-points-modal__loading-inner">
      <app-loader></app-loader>
    </div>
  </div>

  <ng-container *ngIf="!balanceLoading">
  <div class="unlock-with-points-modal__header">
    <div class="unlock-with-points-modal__header-left">
      <button type="button" class="unlock-with-points-modal__icon-btn" (click)="close()" [attr.aria-label]="TEXT.DEFAULT_HEADER">
        <em class="icon-arrow-back"></em>
      </button>
      <span class="unlock-with-points-modal__title">{{ headerTitle }}</span>
    </div>
    <div class="unlock-with-points-modal__header-right">
      <span class="unlock-with-points-modal__balance-label">{{ TEXT.AVAILABLE_BALANCE }}</span>
      <img
        class="unlock-with-points-modal__coin unlock-with-points-modal__coin--sm"
        [src]="coinIconSrc"
        width="24"
        height="24"
        [alt]="LOYALTY_POINTS_TEXT.COIN_ALT"
        loading="lazy"
        decoding="async"
      />
      <span class="unlock-with-points-modal__balance-value">
        {{ currentBalance | number }}{{ TEXT.BALANCE_POINTS_SUFFIX }}
      </span>
    </div>
  </div>

  <hr class="unlock-with-points-modal__rule" />

  <div class="unlock-with-points-modal__body">
    <h2 *ngIf="contentTitle" class="unlock-with-points-modal__content-title">{{ contentTitle }}</h2>
    <p *ngIf="contentDescription" class="unlock-with-points-modal__content-desc">{{ contentDescription }}</p>

    <div class="unlock-with-points-modal__cost-row">
      <div class="unlock-with-points-modal__cost">
        <img
          class="unlock-with-points-modal__coin unlock-with-points-modal__coin--lg"
          [src]="coinIconSrc"
          width="32"
          height="32"
          [alt]="LOYALTY_POINTS_TEXT.COIN_ALT"
          loading="lazy"
          decoding="async"
        />
        <span class="unlock-with-points-modal__cost-points">
          {{ pointsCost | number }}{{ TEXT.COST_POINTS_SUFFIX }}
        </span>
      </div>
      <div
        class="unlock-with-points-modal__badge"
        [class.unlock-with-points-modal__badge--ok]="hasEnoughPoints"
        [class.unlock-with-points-modal__badge--warn]="!hasEnoughPoints"
      >
        <span *ngIf="hasEnoughPoints" class="unlock-with-points-modal__badge-tick-wrap" aria-hidden="true">
          <em class="icon-liteicon-white-tick unlock-with-points-modal__badge-tick"></em>
        </span>
        <em *ngIf="!hasEnoughPoints" class="icon-liteAlert unlock-with-points-modal__badge-icon"></em>
        <span *ngIf="hasEnoughPoints">{{ TEXT.POINTS_AVAILABLE_BADGE }}</span>
        <span *ngIf="!hasEnoughPoints">
          {{ TEXT.NEED_MORE_POINTS_BADGE_PREFIX }}{{ pointsShortfall | number }}{{ TEXT.NEED_MORE_POINTS_BADGE_SUFFIX }}
        </span>
      </div>
    </div>

    <div class="unlock-with-points-modal__primary-actions">
      <app-button
        *ngIf="hasEnoughPoints"
        [btnField]="primaryUnlockButton"
        (handleButtonClick)="onPrimaryClick($event)"
      ></app-button>
      <app-button
        *ngIf="!hasEnoughPoints"
        [btnField]="primaryGetMoreButton"
        (handleButtonClick)="onPrimaryClick($event)"
      ></app-button>
    </div>
  </div>
  </ng-container>

  <app-purchase-points-modal
    [creatorId]="creatorId"
    [isSubmitting]="purchasePointsSubmitting"
    [selectedBundleId]="selectedBundleId"
    (packageSelected)="handlePackageSelected($event)"
  ></app-purchase-points-modal>
</div>
